import React from 'react';
import { OfferFlag, Price, PriceTagContainer } from './styled';

interface IAdvisorPrice {
  optedIntoOffers?: boolean;
  serviceRate: string;
  offerPrice: OfferPrice;
}

export default function PriceTag({
  optedIntoOffers,
  serviceRate,
  offerPrice
}: IAdvisorPrice): JSX.Element {
  return (
    <PriceTagContainer data-testid="price-tag">
      {optedIntoOffers && offerPrice.OfferPitch && (
        <OfferFlag>{offerPrice.OfferPitch}</OfferFlag>
      )}
      <Price strikeThrough={optedIntoOffers && offerPrice.OfferPitch != null}>
        <span className="price">{serviceRate}</span>
        <small className="per-min">/min</small>
      </Price>
    </PriceTagContainer>
  );
}

PriceTag.defaultProps = {
  optedIntoOffers: false
};
